import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import normal from './modules/normal'
import topic from './modules/topic'
import live from './modules/live'
import oneComment from './modules/one-comment'
import askDetail from './modules/ask-detail'
import askTopic from './modules/ask-topic'
import paper from './modules/paper'

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		app,
		normal,
		topic,
		live,
		oneComment,
		askDetail,
		askTopic,
		paper
	}
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js